import { render, staticRenderFns } from "./addUnit.vue?vue&type=template&id=544516ab"
import script from "./addUnit.vue?vue&type=script&lang=js"
export * from "./addUnit.vue?vue&type=script&lang=js"
import style0 from "./addUnit.vue?vue&type=style&index=0&id=544516ab&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports